/*
  UGC Slider ("social proof") — behaviour.

  The track is a Swiper carousel using the theme's existing Swiper chunk (loaded
  by an inline module in the section and exposed as window.fluSwiperModule). This
  file inits the carousel plus the expand-modal / play logic.

  Self-contained and idempotent. Does not touch theme.js.
*/
(function () {
  if (window.__ugcSliderInit) {
    window.__ugcSliderInit();
    return;
  }

  function buildEmbedIframe(type, id, url) {
    var src = "";
    var allow =
      "autoplay; fullscreen; picture-in-picture; encrypted-media; web-share";
    if (type === "youtube" && id) {
      src =
        "https://www.youtube.com/embed/" + id + "?rel=0&playsinline=1&autoplay=1";
    } else if (type === "vimeo" && id) {
      src =
        "https://player.vimeo.com/video/" + id + "?autopause=0&playsinline=1&autoplay=1";
    } else if (url) {
      src = url;
    }
    var iframe = document.createElement("iframe");
    iframe.setAttribute("src", src);
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allow", allow);
    iframe.setAttribute("allowfullscreen", "true");
    return iframe;
  }

  /* Run cb with the Swiper module (loaded by the inline module in the section).
     Handles either order: module ready first, or asset script first. */
  function withSwiperModule(cb) {
    if (window.fluSwiperModule) {
      cb(window.fluSwiperModule);
    } else {
      document.addEventListener(
        "flu:swiper-ready",
        function () {
          cb(window.fluSwiperModule);
        },
        { once: true },
      );
    }
  }

  /* Initialize the Swiper carousel. Idempotent (skips if already a Swiper) and
     safe to call again, so a re-scan on `load` is harmless. */
  function initSwiper(section) {
    var swiperEl = section.querySelector("[data-ugc-track]");
    if (!swiperEl || swiperEl.swiper) return;

    var prev = section.querySelector("[data-ugc-prev]");
    var next = section.querySelector("[data-ugc-next]");
    var isStatic = section.getAttribute("data-mode") === "static";

    withSwiperModule(function (mod) {
      if (!mod || swiperEl.swiper) return;
      var Swiper = mod.Swiper || mod.default;
      var modules = [];
      if (mod.A11y) modules.push(mod.A11y);
      var options = {
        slidesPerView: 1.2,
        spaceBetween: 16,
        watchOverflow: true,
        centerInsufficientSlides: isStatic,
        a11y: { enabled: true },
        breakpoints: {
          480: { slidesPerView: 2.2, spaceBetween: 16 },
          720: { slidesPerView: 3.2, spaceBetween: 24 },
          1024: { slidesPerView: 4.2, spaceBetween: 24 },
          1400: { slidesPerView: 4, spaceBetween: 24 },
        },
      };
      if (prev && next && mod.Navigation) {
        modules.push(mod.Navigation);
        options.navigation = {
          prevEl: prev,
          nextEl: next,
          disabledClass: "swiper-button-disabled",
          lockClass: "swiper-button-lock",
        };
      }
      options.modules = modules;
      new Swiper(swiperEl, options);
      section.classList.add("ugc-slider--ready");
    });
  }

  function initSection(section) {
    // One-time wiring (modal + card clicks). Kept separate from the Swiper init
    // so the carousel can be retried without re-binding events.
    if (section.dataset.ugcSliderInitialized !== "true") {
      section.dataset.ugcSliderInitialized = "true";
      wireModal(section);
    }
    initSwiper(section);
  }

  function wireModal(section) {
    var cards = section.querySelectorAll("[data-ugc-card]");
    var modal = section.querySelector("[data-ugc-modal]");
    var modalContent = null;
    var lastFocused = null;
    var sectionId = section.getAttribute("data-section-id");

    modal.setAttribute("data-ugc-modal-for", sectionId);
    var stale = document.querySelector(
      'body > [data-ugc-modal][data-ugc-modal-for="' + sectionId + '"]',
    );
    if (stale && stale !== modal) stale.parentNode.removeChild(stale);
    document.body.appendChild(modal);
    modalContent = modal.querySelector("[data-ugc-modal-content]");

    function openModal(card) {
      if (!modal || !modalContent) return;
      var videoSrc = card.getAttribute("data-ugc-video-src");
      var embedType = card.getAttribute("data-ugc-embed-type");
      var embedId = card.getAttribute("data-ugc-embed-id");
      var embedUrl = card.getAttribute("data-ugc-embed-url");
      var imageSrc = card.getAttribute("data-ugc-image-src");

      modalContent.innerHTML = "";
      var isImageOnly = false;

      if (videoSrc) {
        var video = document.createElement("video");
        video.src = videoSrc;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute("playsinline", "");
        modalContent.appendChild(video);
      } else if (embedType || embedUrl) {
        modalContent.appendChild(buildEmbedIframe(embedType, embedId, embedUrl));
      } else if (imageSrc) {
        var img = document.createElement("img");
        img.src = imageSrc;
        img.alt = "";
        modalContent.appendChild(img);
        isImageOnly = true;
      } else {
        return;
      }

      modal.classList.toggle("ugc-modal--image", isImageOnly);
      lastFocused = document.activeElement;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("ugc-modal-open");
      var closeBtn = modal.querySelector(".ugc-modal__close");
      if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
    }

    function closeModal() {
      if (!modal || !modalContent) return;
      modalContent.innerHTML = "";
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("ugc-modal-open");
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    cards.forEach(function (card) {
      var opener = card.querySelector("[data-ugc-open]");
      if (opener && card.classList.contains("ugc-card--expandable")) {
        opener.addEventListener("click", function () {
          openModal(card);
        });
      }
    });

    modal.querySelectorAll("[data-ugc-modal-close]").forEach(function (el) {
      el.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });
  }

  function scan() {
    document
      .querySelectorAll('[data-section-type="ugc-slider"]')
      .forEach(initSection);
  }

  window.__ugcSliderInit = scan;
  scan(); // deferred script: the DOM is already parsed when this runs

  // Theme editor: re-init when a section is added or reloaded.
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector('[data-section-type="ugc-slider"]');
    if (el) initSection(el);
  });
})();
